import React from "react";
// import Preview from "../views/Preview";
import HomeLight from "../views/all-home-version/HomeLight";
// import HomeDark from "../views/all-home-version/HomeDark";
import NotFound from "../views/NotFound";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import ScrollTopBehaviour from "../components/ScrollTopBehaviour";

const Routes = () => {
  return (
    <>
      <Router>
        <ScrollTopBehaviour />
        <Switch>
          {/* <Route exact path="/" component={Preview} /> */}
          <Route exact path="/" component={HomeLight} />
          <Route exact path="/about" component={HomeLight} />
          <Route exact path="/portfolio" component={HomeLight} />
          <Route exact path="/contact" component={HomeLight} />
          <Route exact path="/posts" component={HomeLight} />
          <Route exact path="/gallery" component={HomeLight} />
          {/* <Route path="/home-light" component={HomeLight} />
          <Route path="/home-dark" component={HomeDark} /> */}
          <Route component={NotFound} />
        </Switch>
      </Router>
    </>
  );
};

export default Routes;
